define('commons/config-tree',['jquery', 'jquery.ui', 'jquery.fancytree'], function($) {
    var ConfigTree = function(options) {
        this.settings = $.extend({}, {
            imagePath : "/resources/img/hwcfg/",
            activate : function(event, data) {
                $(".tree-node-details").children("div").each(function(index, element) {
                    $(element).hide();
                });
                var node = data.node;
                $("div#" + node.key).show();
            },
            source: [],
            icons: false, // Display node icons.
            debugLevel: 1,
            tree: ".tree"
        }, options);
        // Create fancytree
        this.tree = $(this.settings.tree);
        this.tree.fancytree(this.settings);
    };

    ConfigTree.prototype._sanitizeId = function(parentId, id) {
        return parentId + "_" + id.toString().replace(/[:-]/g, "_");
    };

    ConfigTree.prototype.createTextNode = function(span, node, property) {
        var html = node[property];
        if (typeof html === 'string') {
            html = html.replace(/[\u00A0-\u9999<>\&]/gim, function(i) {
                return '&#'+i.charCodeAt(0)+';';
            }).replace(/\n/g, "<br/>");
        }
        span.append(html);
    };

    ConfigTree.prototype._parseSimpleProperty = function(ul, node, property) {
        var span = $("<span class='property value' />");
        this.createTextNode(span, node, property);
        var li = ul.append("<li></li>").find("li").last();
        li.append("<span class='property title'>" + property + " : </span>").append(span);
    };

    ConfigTree.prototype._parseCompositeProperty = function(ul, node, property) {
        ul.append("<li><span class='property title'>" + property + " : </span><ul></ul></li>");
        var subUl = ul.find("ul");
        for (var i in node[property]) {
            subUl.append("<li><span class='property title'>" + i + " : </span><span class='property value'>" + node[property][i] + "</span></li>");
        }
    };

    ConfigTree.prototype.addButtons = function(div, node) {

    };

    ConfigTree.prototype._buildNode = function(data, parent, initial, selected) {
        var idSanitized = this._sanitizeId(parent.key, data.id);
        var title = this.createTitle(data, idSanitized);
        var node = this.createNode(parent, data, idSanitized, title, selected);

        // create the div containing the details
        $(".tree-node-details").append("<div id='" + idSanitized + "' ><h1>" + title + "</h1><ul></ul></div>");
        var div = $("div#" + idSanitized);
        var ul = div.find("ul");

        // For each node, write the property in the details list
        for (var i in data) {
            if (i != "children") {
                if (typeof data[i] == "object") {
                    this._parseCompositeProperty(ul, data, i);
                } else {
                    this._parseSimpleProperty(ul, data, i);
                }
            }
        }

        div.append("<div class='toolbar' style='margin-top:7px; min-height: 35px;'>");
        this.addButtons(div.find(".toolbar"), data);
        
        if (!selected && !initial) {
            $("#" + idSanitized).hide();
        }
        
        return node;
    };

    ConfigTree.prototype._buildTree = function(data, parent, initial, displayNode, idSelected) {
        var node = parent;
        if (displayNode) {
            node = this._buildNode(data, node, initial, data.id == idSelected);
        }
        // call it again for the children
        if (typeof data.children != "undefined") {
            for (var j = 0; j < data.children.length; ++j) {
                this._buildTree(data.children[j], node, false, true, idSelected);
            }
        }
    };

    ConfigTree.prototype.buildTree = function(data, displayNode, idSelected) {
        if(// if no display node, test there are no children
                (!displayNode && (typeof data.children == "undefined" || data.children.length === 0)) || 
                // If display node, test there is no id
                (displayNode && typeof data.id == "undefined")) {
            this.tree.find("ul").html("<li>No data to display</li>");
        } else {
            this._buildTree(data, this.tree.fancytree("getRootNode"), displayNode, displayNode, idSelected);
        }
    };

    ConfigTree.prototype.isCurrent = function(version){
        if (this.versions != 'undefined' && $.inArray(version, this.versions) >= 0){
            return true;
        }
        return false;
    };

    // Override this method
    ConfigTree.prototype.createTitle = function(data, id) {

    };

    // Override this method
    ConfigTree.prototype.createNode = function(parent, data, id, title, selected) {

    };

    return ConfigTree;
});
